import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1026"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.981 9.862c-.834 0-1.348-.109-2.007-.469-.654 1.09-1.218 2.437-1.394 3.678a21.805 21.805 0 0 0-.812-5.437c-.686-2.458-2.405-4.851-5.651-6.559 1.517 2.211 2.092 4.531 2.41 6.967.263 2.015.228 4.263-.219 5.856a7.76 7.76 0 0 0-.812-3.186c-.679-1.367-1.775-2.644-3.412-3.64.742 1.675 1.209 3.13 1.402 4.369.172 1.112.079 2.125-.278 3.04H9.46v.002h4.769c-.956-1.821-.021-4.675.007-4.81a4.649 4.649 0 0 1-1.255.189z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M15.038 3.967c-.872.156-1.188.845-1.183 1.299-.522-.798-.473-1.646-.272-2.849-2.015.541-1.804 2.76-1.934 3.413-.441-.464-.425-1.456-.425-1.456-.543.216-.88.917-.945 1.508-.157 1.429.879 2.597 2.263 2.749 1.383.152 2.589-.77 2.746-2.199.092-.851-.461-1.196-.25-2.465z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }